export const SMALL_TVL_PARAM = 'smallTvl';

export const STRATEGY_FARM_PARAM = 'strategyFarm';

export const FARM_TYPES_PARAM = 'farmTypes';

export const V3_FARM_TYPES_PARAM = 'v3Type';

export const TAB_PARAM = 'tab';

export const RISK_LEVEL_FROM_PARAM = 'riskFrom';

export const PROFIT_PERCENT_FROM_PARAM = 'profitFrom';

export const PROFIT_PERCENT_TO_PARAM = 'profitTo';

export const RISK_LEVEL_TO_PARAM = 'riskTo';

export const TAGS_PARAM = 'tags';

export const RANGES_PARAM = 'ranges';

export const PLATFORMS_PARAM = 'platforms';

export const PROFIT_TOKENS_PARAM = 'tokens';

export const VAULT_ID_PARAM = 'vaultId';

export const FARM_IDs_PARAM = 'farmIds';

export const EXCHANGES_PARAM = 'exchanges';
